import { useContext } from 'react';

import { CompanyFragment } from '@willow/graphql-iso/src/portal';
import { getCompanyLogoUrl } from '@willow/shared-iso';

import { EnvironmentContext } from '../context/EnvironmentContext';

export const CompanyLogo = ({ company }: { company: CompanyFragment }) => {
  const environment = useContext(EnvironmentContext);

  const logoSrc = getCompanyLogoUrl('portal', company.logos.portalLogoUrl ?? undefined, environment, company.id);

  return <img src={logoSrc} alt={`${company.name} Logo`} />;
};
